<template>
  <div class="welcome-page-template">
    <p>Are you ready to learn and engage. You are free to register completely anonymously, but you must agree to treat everyone you find here civilly.</p>
    <div class="end-comment" style="display: flex; justify-content: center;">
      <img src="@/assets/end-comment.png" width="80px" height="40px" style="margin-top:-5px" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "WelcomePage"
};
</script>

<style lang="scss" scoped>
.welcome-page-template {
  height: 100%;
  p {
    text-align: center;
    font-size: 3vh;
    line-height: 1.5;
    margin-bottom: 16px;
  }
}
</style>